import React from 'react'
import { VerifyValidationButtonStyle } from './style'

export const VerifyValidationButton: React.FC = () => {
  return (
    <VerifyValidationButtonStyle href="/verificar-validacao">
      <img src="/images/icons/user-icon.svg" alt="ícone de usuário" />
      <p>Verificação e Validação de cadastro</p>
    </VerifyValidationButtonStyle>
  )
}
